<template>
  <div class="ui-block">
    <div class="fc fc-ltr fc-unthemed">
      <div class="fc-toolbar">
        <div class="fc-left">
          <div
            v-if="currentWeekNr > 1"
            class="fc-button-group"
          >
            <button
              type="button"
              class="fc-prev-button fc-button fc-state-default fc-corner-left"
              @click="subtractWeek"
            >
              <span class="fc-icon fc-icon-left-single-arrow" />
            </button>
          </div>
        </div>
        <div class="fc-right">
          <div
            v-if="currentWeekNr < weeks.length"
            class="fc-button-group"
          >
            <button
              type="button"
              class="fc-next-button fc-button fc-state-default fc-corner-right"
              @click="addWeek"
            >
              <span class="fc-icon fc-icon-right-single-arrow" />
            </button>
          </div>
        </div>

        <div class="fc-clear" />
      </div>
    </div>

    <div class="ui-block-title">
      <to-do-form />
      <div
        class="day-number"
        style="font-size: 20px;"
      >
        To Dos for Week
      </div>
      <div class="day-week">
        {{ startWeek }} - {{ endWeek }}
        {{ isSameMonth ? startWeekMonth : startWeekMonth + ' ' + endWeekMonth }}, {{ currentYear }}
      </div>
      <div class="control-block-button">
        <a
          href="#"
          class="btn btn-control bg-breez"
          @click="$modal.show('to-do-form', {item: { title:'', date: date1}})"
        >
          <app-icon
            name="olymp-plus-icon"
            color="white"
            size="normal"
          />
        </a>
      </div>
    </div>


    <div class="ui-block-content">
      <ul class="widget w-activity-feed ">
        <li
          v-for="item in items"
          :key="item.id"
          style="border-bottom: 1px dashed #dce1eb ; padding-top: 15px;"
        >
          <div class="checkbox clicked">
            <label @click.prevent="setFlag(item.id, item.flag_done)">
              <input
                name="optionsCheckboxes"
                type="checkbox"
                :checked="item.flag_done"
              ><span class="checkbox-material"><span class="check" /></span>
              {{ item.title }}
            </label>
            <a
              href="#"
              style="margin-left: 15px;"
              @click="$modal.show('to-do-form', { item: item})"
            >
              <app-icon
                name="olymp-three-dots-icon"
                color="gray"
                size="normal"
              />
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { format } from 'date-fns'
  import ToDoForm from './ToDoForm'
  import AppIcon from "../../common-apps/common/AppIcon"
  import toDoStore from "../../../store/modules/personal/to-do.js";

  export default {
    name: 'ToDo',
    components: { ToDoForm, AppIcon },
    props: {
      date: {
        type: Date,
        default: function () { return {} }
      }
    },
    data () {
      return {
        currentYear: format(new Date(),'yyyy'),
        date1: new Date()
      }
    },
    computed: mapState({
      items: state => state.toDo ? state.toDo.items :[],
      weeks: state => state.toDo ? state.toDo.weeks : [],
      startWeek: state => state.toDo ? state.toDo.startWeek : '',
      endWeek: state => state.toDo ? state.toDo.endWeek : '',
      startWeekMonth: state => state.toDo ? state.toDo.startWeekMonth : '',
      endWeekMonth: state => state.toDo ? state.toDo.endWeekMonth : '',
      isSameMonth: state => state.toDo ? state.toDo.isSameMonth : false,
      currentWeekNr: state => state.toDo ? state.toDo.currentWeekNr : 0,
      currentWeek: state => state.toDo ? state.toDo.currentWeek : {}
    }),
    created () {
      if (!this.$store.hasModule('toDo')) {
        this.$store.registerModule('toDo', toDoStore)
      }
      this.$store.dispatch('toDo/getWeeks', { date: this.date })
      this.$store.dispatch('toDo/getCurrentWeek', { weeks: this.weeks, currentWeekNr: this.currentWeekNr, op: 'add' })
    },
    beforeDestroy () {
      this.$store.unregisterModule('toDo')
    },
    methods: {
      addWeek () {
        this.$store.dispatch('toDo/getCurrentWeek', { weeks: this.weeks, currentWeekNr: this.currentWeekNr, op: 'add' })
      },
      subtractWeek () {
        this.$store.dispatch('toDo/getCurrentWeek', { weeks: this.weeks, currentWeekNr: this.currentWeekNr, op: 'subtract' })
      },
      setFlag(id, flag) {
        this.$store.dispatch('toDo/edit', {id: id, flag_done: !flag ? 1 : 0});
      }
    }
  }
</script>
